import { Stack, Typography, Box, useTheme } from '@mui/material'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import colors from 'styles/colors'
import { useTranslation } from 'react-i18next'
import ImageContainer from 'components/atoms/container/ImageContainer'
import SharePublicRolePlayButton from 'components/molecules/rolePlay/SharePublicRolePlayButton'

const circlesImg = require('assets/images/circles.png')
const shareMegaphoneImg = require('assets/images/shareMegaphone.png')
const fakeResultsUiImg = require('assets/images/fakeResultsUI.png')

const PublicRolePlayFooter = () => {
  const { t } = useTranslation()
  const theme = useTheme()

  const Circle = ({ size = 630, right = 0 }) => (
    <Box
      sx={{
        width: size,
        height: size,
        backgroundColor: colors.MutedTeal400,
        borderRadius: size / 2,
        opacity: 0.2,
        position: 'absolute',
        bottom: 0,
        right: right
      }}
    />
  )

  const Circles = () => (
    <Box sx={theme.publicRolePlay.footer.circles}>
      <Circle />
      <ImageContainer
        sx={theme.publicRolePlay.footer.circlesImg}
        src={circlesImg}
        alt='footer image'
      />
    </Box>
  )

  const MegaphoneBox = () => (
    <BoxWithBackground sx={theme.publicRolePlay.footer.megaphoneBox}>
      <ImageContainer src={shareMegaphoneImg} alt='Megaphone image' />

      <ImageContainer
        sx={theme.publicRolePlay.footer.resultsImg}
        src={fakeResultsUiImg}
        alt='Results image'
      />
    </BoxWithBackground>
  )

  return (
    <BoxWithBackground sx={theme.publicRolePlay.footer.container}>
      <Stack
        sx={{
          ...theme.publicRolePlay.stack,
          zIndex: 1,
          alignItems: 'center',
          gap: 25
        }}>
        <Stack gap={10} flex={1}>
          <Stack gap={4}>
            <Typography
              sx={{ ...theme.publicRolePlay.head.h1, color: colors.White }}>
              {t('publicRolePlay.shareAIREWithOthers')}
            </Typography>
            <Typography variant='h4' fontWeight={400} color={colors.White}>
              {t('publicRolePlay.shareAIREWithOthersSubText')}
            </Typography>
          </Stack>

          <SharePublicRolePlayButton
            variant='contained'
            label={t('publicRolePlay.shareAIRE')}
            trackLocation='banner'
          />
        </Stack>

        <MegaphoneBox />
      </Stack>

      <Circles />
    </BoxWithBackground>
  )
}

export default PublicRolePlayFooter
